'use strict';

var _localize = require('linksoft/core/localize');

var _localize2 = _interopRequireDefault(_localize);

var _notify = require('linksoft/notify');

var _notify2 = _interopRequireDefault(_notify);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var $ = require("jquery");


var resx = (0, _localize2.default)("App");

module.exports = exports.default = function () {

    $('#approveUserButton').on('click', function () {
        var userId = $(this).attr('data-user-id');

        $.ajax({
            type: "GET",
            url: '/user/approveUser/0' + userId,
            contentType: "application/json; charset=utf-8",
            success: function success() {
                _notify2.default.success(resx.App.Approved);
                window.location.reload();
            }
        });
    });

    $('[data-control-button-approve-user]').on('click', function () {
        var userId = $(this).attr('data-control-button-approve-user');

        $.ajax({
            type: "GET",
            url: '/user/approveUser/0' + userId,
            contentType: "application/json; charset=utf-8",
            success: function success() {
                _notify2.default.success(resx.App.Approved);
                $("#usersToApprove").DataTable().ajax.reload(null, false);
            }
        });
    });
};


//////////////////
// WEBPACK FOOTER
// ./Scripts/app/approveUser.js
// module id = 411
// module chunks = 0